import React from 'react'
import {
  Dialog,
  Text,
  Flex,
  Button,
  Link,
  Callout,
  Spinner,
} from 'components/ds'
import Icon from 'components/ui/icon'
import { useSelector } from 'react-redux'
import {
  getSubscriptionExpiresAt,
  getSubscriptionLoading,
} from '@disco/state-management/selectors/subscription'
import { formatDate } from '@disco/utils/time-utils'

export const CancelSubscriptionModalStepThree = () => {
  const subscriptionLoading = useSelector(getSubscriptionLoading)
  const subscriptionExpiresAt = useSelector(getSubscriptionExpiresAt)
  const formattedSubscriptionExpiresAt = formatDate(subscriptionExpiresAt)

  return (
    <>
      <Dialog.Title mt="0">
        <Flex justify="between">
          <Text weight="medium" size="5">
            Your subscription is now cancelled
          </Text>
          <Dialog.Close>
            <Button color="gray" variant="ghost">
              <Icon type="close" />
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Title>
      <Dialog.Description size="2" mb="4">
        {subscriptionLoading ? (
          <Flex justify="center">
            <Spinner />
          </Flex>
        ) : (
          <p>
            <Text>
              We’re sorry to see you go! You will have access to your account
              until {formattedSubscriptionExpiresAt}. Please download any tracks
              or files prior to that date.
            </Text>
          </p>
        )}
      </Dialog.Description>
      <Callout.Root color="gray">
        <Callout.Icon>
          <Icon type="info-outline" />
        </Callout.Icon>
        <Callout.Text>
          Didn’t mean to cancel?{' '}
          <Dialog.Close>
            <Link
              href="#"
              className="inline-link"
              data-testid="start-generic-intercom-workflow"
            >
              Contact support
            </Link>
          </Dialog.Close>
        </Callout.Text>
      </Callout.Root>
    </>
  )
}
